import styled from 'styled-components';

const PlayerCardContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 80px;
    flex-wrap: wrap;
`;

export default PlayerCardContainer;
